<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 1.17em;">THANK YOU</span> to Dreamspinner Press and Harmony Ink Press for taking a chance on <span style=" font-style: italic; font-size: 1.00em;">Rage to Live</span>, and to everyone else involved who helped me create the best book possible.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?775fd806